import React, { Component } from "react";
import SolicitudesService from "../../../services/solicitudes/SolicitudesService";
import { trackPromise } from 'react-promise-tracker';
import Popup from "react-popup";
import DataTable from 'react-data-table-component';
import $ from "jquery";

export default class SeleccionTarjeta extends Component {
  constructor(props) {
    super(props);
    this.state = {
      listaTC: undefined,
      lista: [],
      listaAlertasTarjetas:[],
      mensajeTabla:"No hay registros para mostrar"
    };
  }
  componentDidMount() {
    this.setState({ listaAlertasTarjetas: this.obtenerListadoAlertasTarjetas() });
   }
  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });

  buscar = () => {
//carga las tarjetas que posee el socio
    var respuesta = [];
    trackPromise(
      SolicitudesService.getAlertasTarjetas(this.props.telefono)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          //console.log(jsonData)
          if (jsonData.codigoRetorno === "0") {
            for (var i = 0; i < jsonData.resultadoTarjetas.length; i++) {
              respuesta.push({
                id: i + 1,
                marca: jsonData.resultadoTarjetas[i].marca,
                nroTarjeta: jsonData.resultadoTarjetas[i].nroTarjeta,
                suscribir: false,
                adicional: false,
              });
            }
            let vLitaNueva=[];
            for (var i = 0; i < respuesta.length; i++) {
          
              if(!(this.state.listaAlertasTarjetas.find(element => element.nroTarjeta === respuesta[i].nroTarjeta))){
                vLitaNueva.push(respuesta[i]);
              }
             
            }
            if(this.state.listaAlertasTarjetas.length>0){
              this.setState({ listaTC: vLitaNueva });
              if(vLitaNueva.length==0){
                
                this.setState({mensajeTabla:"No posee alertas para agregar, por favor verifique en la seccion de tarjetas de la pantalla principal",
                mostrarTarjetas:false});
               
                
                this.props.parentCallback(false);
              }
            }else{
              this.setState({ listaTC: respuesta });
            }
            
            
            
          }
          else {
           
              
            Popup.queue(this.notifiPopup("Info", "No tiene Tarjetas que mostrar"));
            return;
          }
          this.setState({ listaAlertasTarjetas: this.obtenerListadoAlertasTarjetas() });
        }

        ));

  }

  getColumnTarjeta() {
    return [
      {
        name: "Marca",
        selector: row => row.marca,
      },
      {
        name: "Tarjeta",
        selector: row => row.nroTarjeta,
      },
      {
        name: "Suscribir",
        selector: row => row.suscribir,
        cell: (row) => (
          <input
            id={"radio_" + row.id}
            type="checkbox"
            key={row.id}
            name="rowSuscribir"
            value={row.nroTarjeta}
            checked={row.suscribir}
            onClick={this.selGrupoEvt}
          ></input>
        ),

      },
      {
        name: "Adicional",
        cell: (row) => (
          <input disabled={row.suscribir === false}
            ref={() => this.grupoAdi}
            id={"radio_" + row.nroTarjeta}
            type="checkbox"
            key={row.id}
            name="rowRadioAd"
            checked={row.adicional}
            value={row.nroTarjeta}
            onClick={this.adiGrupoEvt}
          ></input>
        ),

      }
    ]
  }

  selGrupoEvt = (e) => {
    this.preSele = e.currentTarget;

    var respuesta = [];
    var res = false;
    for (var i = 0; i < this.state.listaTC.length; i++) {

      if ("radio_" + this.state.listaTC[i].id === this.preSele.id) {
        var susc = this.state.listaTC[i].suscribir
        if (susc === false)
          res = true;
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: res,
          adicional: this.state.listaTC[i].adicional,
        });
      }
      else {
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: this.state.listaTC[i].suscribir,
          adicional: this.state.listaTC[i].adicional,
        });
      }
    }
    
    this.setState({ listaTC: respuesta });
     this.props.rptSuscribir(this.preSele.value, res);
  
  };
  enableNext() {
     this.checkGrilla();
  }

  checkGrilla(valor) {

    if (this.preSele !== undefined) {
      //console.log($("#" + this.preSele.id).prop("checked"));
      $("#" + this.preSele.id).prop("checked", valor);
    }

  }


  adiGrupoEvt = (e) => {
    this.adiSele = e.currentTarget;
    var respuesta = [];
    var res = false;
    for (var i = 0; i < this.state.listaTC.length; i++) {
      if ("radio_" + this.state.listaTC[i].nroTarjeta === this.adiSele.id) {
        var susc = this.state.listaTC[i].adicional
        if (susc === false)
          res = true;
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: this.state.listaTC[i].suscribir,
          adicional: res,
        });
      }
      else {
        respuesta.push({
          id: i + 1,
          marca: this.state.listaTC[i].marca,
          nroTarjeta: this.state.listaTC[i].nroTarjeta,
          suscribir: this.state.listaTC[i].suscribir,
          adicional: this.state.listaTC[i].adicional,
        });
      }
    }
    this.setState({ listaTC: respuesta });
    
    this.props.rptAdicional(this.adiSele.value, res);
    this.enableNextAdi();
  };
  enableNextAdi() {
    this.checkGrillaAdi();
  }

  checkGrillaAdi(valor) {

    if (this.adiSele !== undefined) {
//console.log("SELECCIONADO ADICIONAL "+this.adiSele.id)
      $("#" + this.adiSele.id).prop("checked", valor);
    }

  }

  handleChange(e, it) {
    var respuesta = this.state.listaTC;
    for (var i = 0; i < this.state.listaTC.length; i++) {
      var susc = this.state.listaTC[i].suscribir
      var res = false;
      if (it.id === this.state.listaTC[i].id && susc === false)
        res = true;
      respuesta.push({
        id: i + 1,
        marca: this.state.listaTC[i].marca,
        nroTarjeta: this.state.listaTC[i].nroTarjeta,
        suscribir: res,
        adicional: this.state.listaTC[i].adicional,
      });
    }
    //this.setState({ listaTC: respuesta });
    //console.log(respuesta)
  }
   //obtener listado de alertas de tarjetas suscriptas
   obtenerListadoAlertasTarjetas = () => {

    trackPromise(
      SolicitudesService.obtenerListadoAlertasTarjetas().then((response) => {
        var respuesta = [];
        var data = JSON.stringify(response.data);
        var jsonData = JSON.parse(data);

        if (jsonData.codigoRetorno === "0") {
         
         

          for (var i = 0; i < jsonData.resultado.length; i++) {
           
            respuesta.push({
              nroTarjeta: jsonData.resultado[i].numeroCuenta,
              adicional: jsonData.resultado[i].adicional,
             

            });
          }
         
        }
        this.setState({ listaAlertasTarjetas: respuesta });
      })
    ).catch(function (error) {
      console.log(error);
    });
    
  };
  render() {
    var tarjetas = []
    if (this.state.listaTC === undefined)
      this.buscar()
    else
      tarjetas = this.state.listaTC
    return (
      <div className="row">
        <div className="col-md-12">
         
           
           <div className="table-responsive">
            <DataTable
            noHeader={true}
              columns={this.getColumnTarjeta()}
              data={this.state.listaTC}
              dense={true}
              striped={true}
              responsive={true}
              noDataComponent={this.state.mensajeTabla}/>
          </div>
        </div>
      </div>
    );
  }
}
